import UsersService from "@velocity-ehs/user-utils-module";

enum AccountTypes {
  Pro = "vehsExplore",
  Lite = "vehsView",
}

const getSigmaAccountType = () => {
  const { permissions } = UsersService;

  return permissions.canExploreReportingData
    ? AccountTypes.Pro
    : AccountTypes.Lite;
};

const APPLICATION_TEAMS = {
  ehs_ia: "vehs_audit",
  chem: "vehs_chem",
  ehs_compl: "vehs_compliance",
  cow: "vehs_cow",
  ih: "vehs_ih",
  saf: "vehs_incident",
  ergo: "vehs_ind_ergo",
  ehs_meetings: "vehs_meetings",
  ehs_metrics: "vehs_metrics",
  ehs_moc: "vehs_moc",
  oergo: "vehs_off_ergo",
  risk: "vehs_oprisk",
  ehs_jsa: "vehs_standard_jsa",
  ehs_train: "vehs_training",
};

const PROD_ENV = "prod";

const getEnvSuffix = (): string => {
  const env = process.env.SIGMA_ENV;
  return env ? `_${env}` : "";
};

const getSigmaTeamNames = (): string => {
  const { permissions, customer } = UsersService;
  const isAdmin = permissions.canExploreReportingData;
  const teamNames: string[] = [];
  const isProd = process.env.SIGMA_ENV === PROD_ENV;
  const envSuffix = getEnvSuffix();

  const pushTeam = (team: string, skipSuffix = false) => {
    const baseName = skipSuffix ? team : `${team}${envSuffix}`;
    teamNames.push(baseName);

    if (isAdmin) {
      const adminName = skipSuffix
        ? `${team}_admins`
        : `${team}_admins${envSuffix}`;
      teamNames.push(adminName);
    }
  };

  // Every user gets the all_clients team
  pushTeam("vehs_all_clients");

  // Add teams for assigned customer applications
  customer.applications.items.forEach(({ code, isAssigned }) => {
    const team = APPLICATION_TEAMS[code];
    if (isAssigned && team) {
      pushTeam(team);
    }
  });

  // Add teams based on the customer's domain — skip suffix only in prod
  pushTeam(customer.customerDomainName, isProd);

  return teamNames.join(",");
};

export { getSigmaAccountType, getSigmaTeamNames };
